<!-- Enterprise Footer Wrapper - renders enterprise-specific footer based on context -->
<ng-container [ngSwitch]="enterpriseKey">
    <!-- Redefine Enterprise -->
    <app-redefine-footer *ngSwitchCase="'redefine'"></app-redefine-footer>

    <!-- Default: ParkUpp footer (falls through to standard footer) -->
    <ng-container *ngSwitchDefault>
        <!-- Standard ParkUpp footer would go here, but we typically use app-footer directly -->
    </ng-container>
</ng-container>
